import * as types from '../actions/actionTypes.js';
import initialState from "./initialState.js";
import { omit } from 'lodash'


export function listResourceCollectionReducer(
  state = initialState.listResourceCollections, action
  ) {
  switch(action.type) {
    case types.FETCH_LIST_RESOURCE_COLLECTION_SUCCESS:
      return action.listResourceCollections;
    default:
      return state;
  }
}

export function liveSchedulesReducer(
  state = initialState.liveSchedules, action
  ) {
  switch(action.type) {
    case types.FETCH_LIVE_SCHEDULES_SUCCESS:
      return action.liveSchedules;
    default:
      return state;
  }
}

export function editModeReducer(
  state = initialState.editMode, action
  ) {
  switch(action.type) {
    case types.UPDATE_EDIT_MODE_STATUS:
      return {
        ...state,
        status: action.payload
      };
    default:
      return state;
  }
}

export function liveScheduleOptimisticReRenderReducer(
  state = initialState.liveScheduleOptimisticReRender, action
  ) {
  switch(action.type) {
    case types.UPDATE_LIVE_SCHEDULE_OPTIMISTIC_RERENDER_STATUS:
      return {
        ...state,
        status: action.payload
      };
    default:
      return state;
  }
}

export function liveScheduleOptimisticScheduleReducer(
  state = initialState.liveScheduleOptimisticSchedule, action
  ) {
  switch(action.type) {
    case types.UPDATE_OPTIMISTIC_LIVE_SCHEDULE:
      return {
        ...state,
        newLiveSchedule: action.payload
      };
    case types.LIVE_SCHEDULE_DELETE_TOUR_OPTIMISTIC:
      return {
          ...state,
          newLiveSchedule: [
            ...state.newLiveSchedule.map(
              (elem) => {
                if (elem.rId === action.itemDetails.group) {
                  return {
                    ...elem,
                    dayTypes: {
                      ...elem.dayTypes,
                      [action.itemDetails.rdtId]: {
                       ...elem.dayTypes[action.itemDetails.rdtId],
                       tour: null // delete target tour
                      }
                    }
                  }
                } else {
                  return elem; // ignore other resources
                }
              }
            )
          ]
      };
      case types.LIVE_SCHEDULE_ADD_TOUR_OPTIMISTIC:
        return {
            ...state,
            newLiveSchedule: [
              ...state.newLiveSchedule.map(
                (elem) => {
                  if (elem.rId === action.resourceId) {
                    return {
                      ...elem,
                      dayTypes: {
                        ...elem.dayTypes,
                        [action.dayType.rdtId]: action.dayType  // insert new dayType w/ new tour
                      }
                    }
                  } else {
                    return elem; // ignore other resources
                  }
                }
              )
            ]
        };
        case types.LIVE_SCHEDULE_EDIT_TOUR_OPTIMISTIC:
          return {
            ...state,
            newLiveSchedule: [
              ...state.newLiveSchedule.map(
                (elem) => {
                  if (elem.rId === action.updatedResource.rId) {
                    return action.updatedResource // replace target resource
                  } else {
                    return elem; // ignore other resources
                  }
                }
              )
            ]
        };
        case types.LIVE_SCHEDULE_ADD_DAY_TYPE_OPTIMISTIC:
          return {
              ...state,
              newLiveSchedule: [
                ...state.newLiveSchedule.map(
                  (elem) => {
                    if (elem.rId === action.resourceId) {
                      return {
                        ...elem,
                        dayTypes: {
                          ...elem.dayTypes,
                          [action.dayType.rdtId]: action.dayType  // insert new dayType
                        }
                      }
                    } else {
                      return elem; // ignore other resources
                    }
                  }
                )
              ]
          };
        case types.LIVE_SCHEDULE_DELETE_DAY_TYPE_OPTIMISTIC:
          return {
            ...state,
            newLiveSchedule: [
              ...state.newLiveSchedule.map(
                (elem) => {
                  if (elem.rId === action.itemDetails.group) {
                    return {
                      ...elem,
                      // delete target dayType (also checking for optimistic dayTypes) + check for regular dayType/dayOff + finally must be assignment-dayType
                      dayTypes: omit(elem.dayTypes, action.itemDetails.id.toString().split('-')[1] === 'optimistic' ? action.itemDetails.id : action.itemDetails.resourceDayType ? action.itemDetails.resourceDayType.resourceDayTypeId : action.itemDetails.id)
                    }
                  } else {
                    return elem; // ignore other resources
                  }
                }
              )
            ]
          }
          case types.LIVE_SCHEDULE_EDIT_DAY_TYPE_OPTIMISTIC:
            return {
                ...state,
                newLiveSchedule: [
                  ...state.newLiveSchedule.map(
                    (elem) => {
                      if (elem.rId === action.updatedResource.rId) {
                        return action.updatedResource // replace target resource
                      } else {
                        return elem; // ignore other resources
                      }
                    }
                  )
                ]
            };
    default:
      return state;
  }
}

export function liveScheduleParametersReducer(
  state = initialState.liveScheduleParameters, action
) {
  switch (action.type) {
      case types.EDIT_LIVE_SCHEDULE_PARAMETERS_SUCCESS:
          return action.parameters;
      default:
          return state;
  }
}

